// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__3Xlyl","required":"Label_required__12P3B Label_label__3Xlyl"};